import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function countWords(text: string): number {
  if (!text) return 0;
  
  // Count CJK characters (including punctuation commonly used in CJK if needed, but usually just chars)
  // Using a broad range for CJK Unified Ideographs
  const cjkMatch = text.match(/[\u4e00-\u9fa5]/g);
  const cjkCount = cjkMatch ? cjkMatch.length : 0;

  // Replace CJK characters with space to isolate English words
  const cleanText = text.replace(/[\u4e00-\u9fa5]/g, " ");
  
  // Split by whitespace and filter empty strings to count English/Latin words
  const westernCount = cleanText.trim().split(/\s+/).filter(Boolean).length;

  return cjkCount + westernCount;
}
